import {isNilOrEmpty} from 'ramda-adjunct';

import {useGetDirectSaleQuery} from '@dms/api/warehouse';

export function useTaskRelationDirectSale(directSaleId: string) {
  const {
    data: directSale,
    isLoading: isDirectSaleLoading,
    isError: isDirectSaleError,
  } = useGetDirectSaleQuery({directSaleId}, {skip: isNilOrEmpty(directSaleId)});

  return {
    directSale,
    isLoading: isDirectSaleLoading,
    isError: isDirectSaleError,
  };
}
